export default "__VITE_ASSET__UyVTdC5___"